<template>
  <div class="p-4">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="80px"
    >
      <AudienceTarget
        v-model="form.campaignCriterion.target"
        :enumConstants="enumConstants"
        :currentAccount="createAdAccount"
        :auto-fill="true"
        :data="bigData"
        selectWidth="full"
        location-label="地区"
        location-prop="campaignCriterion.target.locations"
        language-label="语言"
        language-prop="campaignCriterion.target.languages"
        @input="onCampaignCriterionChange"
      />
      <el-form-item
        label=""
        prop="campaignCriterion.geoTargetType"
      >
        <el-radio-group
          v-model="form.campaignCriterion.geoTargetType"
          @change="onCampaignCriterionChange"
        >
          <el-radio
            class="mb-4"
            label="PRESENCE_OR_INTEREST"
            >位于您已包含的地理位置、经常身处这些位置或对这些位置表现出兴趣的用户（推荐）</el-radio
          >
          <el-radio label="PRESENCE">位于您已包含的地理位置或经常身处这些位置的用户</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import AudienceTarget from '@/views/google/create/components/audience/AudienceTarget/index.vue';
export default {
  name: 'AdCampaign',
  props: {
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    createAdAccount: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bigData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { AudienceTarget },
  data() {
    return {
      form: {
        campaignCriterion: {
          target: {
            locations: [],
            excludeLocations: [],
            languages: [],
          },
          geoTargetType: 'PRESENCE_OR_INTEREST',
        },
      },
      rules: {
        'campaignCriterion.target.locations': [
          {
            required: true,
            message: '请选择至少一个地区',
            trigger: 'change',
          },
        ],
      },
    };
  },
  created() {
    this.initData();
  },
  watch: {
    value: {
      handler() {
        this.initData();
      },
      deep: true,
    },
  },
  methods: {
    initData() {
      if (this.value && this.value.target) {
        this.form.campaignCriterion = {
          target: { ...this.value.target },
          geoTargetType: this.value.geoTargetType || 'PRESENCE_OR_INTEREST',
        };
      }
    },
    onCampaignCriterionChange() {
      this.$emit('input', this.form.campaignCriterion);
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, errors) => {
          if (valid) {
            resolve(true);
          } else {
            const errorMessages = Object.values(errors)
              .flat()
              .map((error) => error.message);
            reject(errorMessages);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-form-item {
  margin-bottom: 20px;
}
</style>
